import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const slackChannel = defineChannel({
  id: 'slack',
  icon: 'slack',
} as const satisfies ChannelDefinition);
